// GENERATED by scripts/gen-hooks.mjs. Do not edit by hand.
// 20 hooks for backend/disputes.

import { useBackend } from '../useBackend'

/** POST /api/disputes/addDisputeRecommendation */
export function useAddDisputeRecommendation<T = any>() {
  return useBackend<T>('disputes/addDisputeRecommendation')
}

/** POST /api/disputes/closeDisputeMatter */
export function useCloseDisputeMatter<T = any>() {
  return useBackend<T>('disputes/closeDisputeMatter')
}

/** POST /api/disputes/confirmDisputeMatter */
export function useConfirmDisputeMatter<T = any>() {
  return useBackend<T>('disputes/confirmDisputeMatter')
}

/** POST /api/disputes/createDisputeMatter */
export function useCreateDisputeMatter<T = any>() {
  return useBackend<T>('disputes/createDisputeMatter')
}

/** POST /api/disputes/decideDisputeRecommendation */
export function useDecideDisputeRecommendation<T = any>() {
  return useBackend<T>('disputes/decideDisputeRecommendation')
}

/** POST /api/disputes/getDisputeAccess */
export function useGetDisputeAccess<T = any>() {
  return useBackend<T>('disputes/getDisputeAccess')
}

/** POST /api/disputes/getDisputeBoard */
export function useGetDisputeBoard<T = any>() {
  return useBackend<T>('disputes/getDisputeBoard')
}

/** POST /api/disputes/getDisputeCalendar */
export function useGetDisputeCalendar<T = any>() {
  return useBackend<T>('disputes/getDisputeCalendar')
}

/** POST /api/disputes/getDisputeDocumentUrl */
export function useGetDisputeDocumentUrl<T = any>() {
  return useBackend<T>('disputes/getDisputeDocumentUrl')
}

/** POST /api/disputes/getDisputeDriverCandidates */
export function useGetDisputeDriverCandidates<T = any>() {
  return useBackend<T>('disputes/getDisputeDriverCandidates')
}

/** POST /api/disputes/getDisputeMatter */
export function useGetDisputeMatter<T = any>() {
  return useBackend<T>('disputes/getDisputeMatter')
}

/** POST /api/disputes/pushDisputeCalendar */
export function usePushDisputeCalendar<T = any>() {
  return useBackend<T>('disputes/pushDisputeCalendar')
}

/** POST /api/disputes/readDisputeDocument */
export function useReadDisputeDocument<T = any>() {
  return useBackend<T>('disputes/readDisputeDocument')
}

/** POST /api/disputes/recordDisputeDocument */
export function useRecordDisputeDocument<T = any>() {
  return useBackend<T>('disputes/recordDisputeDocument')
}

/** POST /api/disputes/recordDisputeEventOutcome */
export function useRecordDisputeEventOutcome<T = any>() {
  return useBackend<T>('disputes/recordDisputeEventOutcome')
}

/** POST /api/disputes/saveDisputeEvent */
export function useSaveDisputeEvent<T = any>() {
  return useBackend<T>('disputes/saveDisputeEvent')
}

/** POST /api/disputes/saveDisputePolicy */
export function useSaveDisputePolicy<T = any>() {
  return useBackend<T>('disputes/saveDisputePolicy')
}

/** POST /api/disputes/signDisputeUpload */
export function useSignDisputeUpload<T = any>() {
  return useBackend<T>('disputes/signDisputeUpload')
}

/** POST /api/disputes/supersedeDisputeEvent */
export function useSupersedeDisputeEvent<T = any>() {
  return useBackend<T>('disputes/supersedeDisputeEvent')
}

/** POST /api/disputes/withdrawDuplicateMatter */
export function useWithdrawDuplicateMatter<T = any>() {
  return useBackend<T>('disputes/withdrawDuplicateMatter')
}
